import { useState } from "react";
import { Handshake, UserRound, UsersRound } from "lucide-react";
import PageShell from "../../components/shared/page-shell/page-shell.tsx";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs/tabs.tsx";
import { PreJoinFormTab } from "../../components/features/onboard-form/tabs/pre-join-form-tab.tsx";
import { PostJoinFormTab } from "../../components/features/onboard-form/tabs/post-join-form-tab.tsx";
import { ConsultantCategoryPanel } from "../../components/features/onboard-form/consultant/consultant-category-panel.tsx";
import { useOnboardingEmployeeNames } from "../../components/features/onboard-form/hooks/use-onboarding-employee-names.ts";
import styles from "./onboard-form-page.module.css";
import { useSqeLabs } from "../../hooks/use-sqe-labs.ts";

export type OnboardFormPageProps = { title?: string; description?: string };
const CATEGORIES = [
  { id: "regular", label: "Regular Employees", description: "Onboard Indian & US employees", icon: UsersRound },
  { id: "india", label: "Indian Consultants", description: "Single step onboarding", detail: "", icon: UserRound },
  { id: "us", label: "US Consultants", description: "Single step onboarding", detail: "", icon: UserRound },
  { id: "vendor", label: "US Consultant (Vendor)", description: "Single step onboarding", detail: "", icon: Handshake },
];

export default function OnboardFormPage({ title, description }: OnboardFormPageProps) {
  const isSqe = useSqeLabs();
  const { options: employeeOptions, loading: employeeOptionsLoading } = useOnboardingEmployeeNames();
  const [category, setCategory] = useState("regular");
  const [activeTab, setActiveTab] = useState("pre-join");
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");

  return (
    <PageShell>
      <Tabs value={category} onValueChange={setCategory} className={styles.tabsRoot}>
        <TabsList className={styles.categoryList}>
          {(isSqe ? CATEGORIES.slice(0, 1) : CATEGORIES).map(({ id, label, description: hint, detail, icon: Icon }) => (
            <TabsTrigger key={id} value={id} className={styles.categoryCard}>
              <Icon size={22} aria-hidden />
              <span className={styles.categoryCopy}>
                <h3 className="heading-xs">{label}</h3>
                <span>{isSqe ? "Onboard SQE Labs employees" : hint}</span>
                {detail && <span>{detail}</span>}
              </span>
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="regular" className={styles.contentPanel}>
          <Tabs value={activeTab} onValueChange={setActiveTab}>
            <TabsList className={styles.flowTabs}>
              <TabsTrigger value="pre-join" className={styles.flowTab}>Pre-Join Invites</TabsTrigger>
              <TabsTrigger value="post-join" className={styles.flowTab}>Post-Join Invites</TabsTrigger>
            </TabsList>
            <TabsContent value="pre-join">
              <PreJoinFormTab employeeOptions={employeeOptions} employeeOptionsLoading={employeeOptionsLoading} selectedEmployeeId={selectedEmployeeId} onSelectedEmployeeIdChange={setSelectedEmployeeId} active={category === "regular" && activeTab === "pre-join"}   consultantType="REGULAR"
 />
            </TabsContent>
            <TabsContent value="post-join">
              <PostJoinFormTab active={category === "regular" && activeTab === "post-join"} />
            </TabsContent>
          </Tabs>
        </TabsContent>
        {!isSqe && CATEGORIES.filter((item) => item.id !== "regular").map((item) => (
          <TabsContent key={item.id} value={item.id} className={styles.contentPanel}>
            <ConsultantCategoryPanel label={item.label} region={item.id === "india" ? "INDIA" : "US"} consultantType={item.id === "vendor" ? "vendor" : "direct"} requestorOptions={employeeOptions} active={category === item.id} />
          </TabsContent>
        ))}
      </Tabs>
    </PageShell>
  );
}
